import React from 'react';
import { LANGUAGES } from '../data/conversations';

const QA = [
  [
    'Will callers know they’re talking to an AI?',
    'It sounds natural and friendly, and you choose the greeting. Callers who would rather speak to a person can press a key to be transferred to your staff.',
  ],
  [
    'How do orders get to my kitchen?',
    'Every order prints automatically on your kitchen printer and appears in the admin portal and on the counter tablet. The tablet sounds a loud alert for each new order, even when the screen is locked.',
  ],
  [
    'What happens when a dish is sold out?',
    'Mark it unavailable in the admin portal with one tap. The phone AI, kiosk and website stop offering it immediately. The AI suggests the substitutes you chose instead.',
  ],
  [
    'What about calls after we close?',
    'The AI tells callers your opening hours. If you prefer, turn on pre-orders: it takes the order, tells the caller when it will be ready after you open, and prints the ticket marked as a pre-order.',
  ],
  ['Which languages does it speak?', `${LANGUAGES.map((l) => l.name).join(', ')}, and many more. If your customers speak it, ask us.`],
  [
    'Can I keep my current phone number?',
    'Yes. You can forward your existing number to the AI, or we can set you up with a new one.',
  ],
  [
    'How do customers pay?',
    'At the counter, or online by card if you connect a Stripe account. You can also hold large orders until they’re paid.',
  ],
  [
    'How long does setup take?',
    'Most of the work is on our side. Send us your menu, we build and test your assistant, and you go live once you’re happy with how it sounds.',
  ],
];

export default function FAQ() {
  return (
    <section className="section light section--tight-top" id="faq">
      <div className="wrap faq">
        <div className="faq__head" data-reveal>
          <p className="eyebrow">FAQ</p>
          <h2 className="h2">
            Questions owners <em>ask us first.</em>
          </h2>
        </div>
        <div className="faq__list">
          {QA.map(([q, a]) => (
            <details key={q} className="qa" data-reveal>
              <summary>
                {q}
                <span className="qa__icon" aria-hidden="true" />
              </summary>
              <p>{a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
